






















import { Component, Vue, Watch } from 'vue-property-decorator';
import { checkUsers, getFromType } from '@/api/task/crowd';

import { detail as taskDetail } from '@/api/task/common';
import { detail as judgeDetail } from '@/api/task/judge';
import { PAGINATION_PARAM, DOMAIN } from '@/global/constants';

@Component
export default class Check extends Vue {
  private userList: object[] = [];
  private total: number | string = 0;
  private task: object = {};
  private params: object = {
    gid: '',
    uid: '',
    ...PAGINATION_PARAM,
  };
  private columnsSchema: object[] = [
    {
      title: '分组名称',
      key: 'title',
      align: 'center',
    },
    {
      title: '用户ID',
      key: 'uid',
      align: 'center',
    },
    {
      title: '题数',
      key: 'nums',
      align: 'center',
    },
    {
      title: '失败次数',
      key: 'check_fail_nums',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'operate',
      align: 'center',
    },
  ];
  @Watch('$route')
  private routechange(to: any, from: any) {
    if (to.name == 'check') {
      this.getList({});
      this.getTask(); // 重新加载数据
    }
  }
  private created() {
    this.getTask();
  }
  private async getTask() {
    this.task = this.$store.state.task;
    if (!(this.task && (this.task as any).id)) {
      const page = this.$route.params.page;
      const params = { id: this.$route.params.id };
      let resp: any;
      if (page == 'judge') {
        resp = await judgeDetail(params);
      } else {
        resp = await taskDetail(params);
      }
      this.$nextTick(() => {
        this.task = resp.result;
        this.$store.commit('setTask', resp.dta);
        this.getParams();
      });
    } else {
      this.getParams();
    }
  }
  private getParams() {
    const gId = this.$route.params.gid || (this.task as any).gid;
    this.params = Object.assign(this.params, { gid: gId });
    this.getList(this.params);
  }
  private async getList(params) {
    try {
      const data = (await checkUsers(params)) as any;
      this.$nextTick(() => {
        this.userList = data.rows;
        this.total = data.total;
      });
    } catch (error) {
      console.log(error);
    }
  }
  // 审核
  private async handlecheck(uid, gid) {
    try {
      const res: any = await getFromType({ gid: gid });
      let from = res.from;
      if (from.indexOf('sketch') > -1) {
        from = from.indexOf('-') > -1 ? from.split('-')[1] : 'markPage';
      }
      window.open(
        `${DOMAIN}/tools/${from}.html?type=21&id=${
          (this.task as any).id
        }&gid=${gid}&uid=${uid}`
      );
    } catch (error) {
      console.log(error);
    }
  }
  // 搜索
  private handleSearch(id) {
    if (id && !/^\d+$/.test(id)) {
      this.$Notice.error({ title: '提示', desc: '无效的用户ID' });
      return;
    }
    this.params = Object.assign(this.params, {
      gid: (this.task as any).gid,
      uid: id,
      page: 1,
    });
    this.getList(this.params);
  }
  // 分页
  private changePage(data) {
    this.params = Object.assign(this.params, {
      page: data,
    });
    this.getList(this.params);
  }
}
